import React from 'react';
import { SongCard } from '@components/basics/SongCard';

export const SearchSongCardSkeleton = () => {
  return (
    <SongCard
      album={false}
      isPlaying={false}
      edition={false}
      expanded={null}
      setExpanded={null}
      loading
    >
      <SongCard.Cover
        image={null}
        onPlayButtonClick={() => {
          return;
        }}
        currentListeningParty={null}
      />
      <SongCard.Info
        header={null}
        subheader={null}
        actions={null}
        bottom={<div className="h-[38px]" />}
      />
    </SongCard>
  );
};
